<template>
  <!-- Footer -->
  <section id="footer">
    <section id="socialmedia">
      <SocialMedia v-if="!isWrapped" />
    </section>
    
    <ul class="localization" v-if="hasMultipleLanguage">
      <li v-for="lang in supportedLanguages" v-bind:key="lang">
          <button class="languageCode" v-on:click="changeLanguage(lang)">{{lang}}</button>
      </li>
    </ul>
    <p class="copyright">
      &copy; Fernando Mata 2019. Design:
      <a href="http://html5up.net">HTML5 UP</a>.
    </p>

  </section>
</template>

<script>
import { Trans } from '../localization/Translation.js'
import SocialMedia from  './SocialMedia.vue'

export default {
  name: 'footer',
  components: {
      SocialMedia
  },
  computed: {
    supportedLanguages () {
      return this.$route.meta.supportedLanguages
    },
    currentLanguage () {
      return Trans.currentLanguage
    },
    isWrapped() {
      return this.$route.meta.isWrapped
    },
    hasMultipleLanguage() {
      return this.$route.meta.hasLanguages
    }
  },
  methods: {
    changeLanguage (e) {
      const lang = e
      const to = this.$router.resolve({ params: { lang } })
      return Trans.changeLanguage(lang).then(() => {
        this.$router.push(to.location)
      })
    },
    isCurrentLanguage (lang) {
      return lang === this.currentLanguage
    }
  }
}
</script>

<style>
.languageCode {
  text-transform: uppercase;
}
.button {
  display: block;
	border-bottom: 0;
  background:none;
  color: #aaaaaa;
  font: inherit;
  cursor: pointer;
}
</style>